import * as c from './types';

export const initState = [];

// eslint-disable-next-line @typescript-eslint/default-param-last
const alerts = (state = initState, { type, payload }) => {
  switch (type) {
    case c.ALERT.ADD:
      return [...state, payload];
    case c.ALERT.DISMISS_LAST:
      return state.slice(1);
    case c.ALERT.DISMISS_BY_ID:
      return state.filter((message) => message.id !== payload);
    case c.ALERT.DISMISS_BY_TYPE:
      return state.filter((message) => message.type !== payload);
    case c.ALERT.DISMISS_BY_CUSTOM_TYPE:
      return state.filter((message) => message.alertType !== payload);
    case c.ALERT.DISMISS_ALL:
      return initState;
    default:
      return state;
  }
};

export default alerts;
